<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.homeNotice.query.title')" prop="title">
                <a-input v-model="queryParam.title" :placeholder="$t('views.homeNotice.query.titlePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.homeNotice.query.sort')" prop="sort">
                  <a-input v-model="queryParam.sort" :placeholder="$t('views.homeNotice.query.sortPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.homeNotice.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.homeNotice.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:homeNotice:add']">
          <a-icon type="plus" />{{ $t('views.homeNotice.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:homeNotice:edit']">
          <a-icon type="edit" />{{ $t('views.homeNotice.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:homeNotice:remove']">
          <a-icon type="delete" />{{ $t('views.homeNotice.btn.delete') }}
        </a-button>
        <table-setting
          :key="$i18n.locale"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:homeNotice:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:homeNotice:edit']">
            <a-icon type="edit" />{{ $t('views.homeNotice.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:homeNotice:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:homeNotice:remove']">
            <a-icon type="delete" />{{ $t('views.homeNotice.btn.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageHomeNotice, delHomeNotice, updateHomeNotice } from '@/api/user/homeNotice'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'HomeNotice',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      columns: [],
      queryParam: {
        title: null,
        content: null,
        contentEn: null,
        sort: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  created () {
    this.buildColumns()
    this.getList()
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    }
  },
  methods: {
    paginationShowTotal (total) {
      return this.$t('views.homeNotice.pagination.total', { total })
    },
    buildColumns () {
      this.columns = [
        {
          title: this.$t('views.homeNotice.column.id'),
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.homeNotice.column.title'),
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.homeNotice.column.content'),
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.homeNotice.column.contentEn'),
          dataIndex: 'contentEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.homeNotice.column.sort'),
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.homeNotice.column.status'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.homeNotice.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.homeNotice.column.operation'),
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    getList () {
      this.loading = true
      pageHomeNotice(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        title: undefined,
        content: undefined,
        contentEn: undefined,
        sort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('views.homeNotice.confirm.deleteTitle'),
        content: this.$t('views.homeNotice.confirm.deleteContent', { ids: ids }),
        onOk () {
          const data = []
          that.ids.map(id => data.push({ id: id }))
          return delHomeNotice(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.homeNotice.msg.deleteSuccess'),
                3
              )
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.homeNotice.confirm.exportTitle'),
        content: this.$t('views.homeNotice.confirm.exportContent'),
        onOk () {
          that.download('user/home-notice/export', {
            ...that.queryParam
          }, that.$t('views.homeNotice.export.filename', { time: new Date().getTime() }))
        },
        onCancel () {}
      })
    },
    handleStatusChange (record, checked) {
      const statusValue = checked ? 1 : 0
      const updateData = {
        id: record.id,
        status: statusValue
      }
      updateHomeNotice(updateData).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.homeNotice.msg.statusUpdateSuccess'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.homeNotice.msg.statusUpdateFail'))
      })
    },
    handleSortChange (record, value, fieldName) {
      if (value === null || value === undefined) {
        return
      }
      const updateData = {
        id: record.id
      }
      updateData[fieldName] = value
      updateHomeNotice(updateData).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.homeNotice.msg.sortUpdateSuccess'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.homeNotice.msg.sortUpdateFail'))
      })
    }
  }
}
</script>
